import { z } from 'zod/v4';
import { InteractionType } from '../../interactions/index.js';
import { Lang } from '../../lang/Lang.js';
import { TemplateState } from '../../templates/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    type: z.enum(InteractionType).optional(),
    state: z
        .enum(TemplateState)
        .optional()
        .describe('Filter by template state. When omitted, only PUBLISHED templates are returned (drafts and version-history rows are excluded).'),
});
const itemSchema = z.object({
    templateId: z.uuid(),
    name: z.string(),
    type: z.enum(InteractionType),
    language: z.enum(Lang).nullable(),
    subject: z.string().nullable(),
    snippet: z
        .string()
        .describe('First ~200 chars of the template body. Call get_template for the full body.'),
});
const facetsSchema = z.object({
    byType: z.record(z.enum(InteractionType), z.number().int()),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchTemplatesTool = {
    name: ToolName.SearchTemplates,
    category: ToolCategory.Templates,
    weight: ToolWeight.Light,
    version: 2,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Discover interaction templates configured for this tenant. Templates are tenant-stable for the whole run — call ONCE with no arguments to enumerate everything; the facets and name/subject/type per item are usually enough to decide which one to read in full. Do NOT search repeatedly with different queries to look for the same kind of template. Use filters.type to scope by channel, including CLIENT NOTE for creditor messages. The list view is identification only — call get_template for the body. When a template fits, preserve its structure and mentions and pass its templateId in the heavy proposal.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-templates.js.map